import { Box, Button, TextField } from "@mui/material";
import {
    Form,
    useLoaderData
} from "react-router-dom";
import { Result } from "../../types/Result";
import { Profession } from "../professions/type";

export default function ProfessionForm() {
    const data = useLoaderData() as Result<Profession>;
    return (
        <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '800px' } }}>
            <Form method="post">
                <TextField
                    placeholder="Kod"
                    type="text"
                    name="professionCode"
                    value={data.data?.professionCode}
                    fullWidth
                    margin="dense"
                    label="Kod"
                    disabled
                />
                <TextField
                    placeholder="Ad"
                    type="text"
                    name="name"
                    defaultValue={data.data?.name}
                    fullWidth
                    margin="dense"
                    label="Ad"
                    required
                />
                <Button fullWidth type="submit" variant="contained">Kaydet</Button>
            </Form>
        </Box>
    );
}